import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import { StatusColorService } from 'projects/shared/src/lib/services/status-color.service';
import { StatusColorDto } from 'projects/shared/src/lib/models/StatusColorDto';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlOptionDto } from 'projects/shared/src/lib/models/ControlOptionDto';

@Component({
  selector: 'level-status',
  templateUrl: './level-status.component.html',
  styleUrls: ['./level-status.component.scss']
})
export class LevelStatusComponent implements OnInit {

  optionForm!: FormGroup;

  errorMessage!: string;

  levels:string[] = [];
  color!: string;
  dbName!: string | null;

  controlOptionDto!: ControlOptionDto;
  

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private _bottomSheetRef: MatBottomSheetRef<LevelStatusComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private statusColorService: StatusColorService,
    private dataSharingService: DataSharingService) { }

  ngOnInit(): void {

    // this.dataSharingService.shareDbNameChanges$.subscribe({
    //   next: (dbname: any) => {
    //     this.dbName = dbname as string;
    //   },
    //   // error
    // });
    this.dataSharingService.activeProjectName.subscribe({
      next:(dbname:string) => {
        this.dbName= dbname
      },
      // error
    });
    
   // this.levels = this.data.valueList.split(',');
   console.log(this.data)

   this.createOptionForm();
  }

  createOptionForm(){
    this.optionForm = this.formBuilder.group({
      label:[null, Validators.required],
      value:[null, Validators.required]
    });
  }

  onSubmit(){
    if(this.optionForm.valid){
      let controlOptionDto = new ControlOptionDto;

      controlOptionDto.label = this.optionForm.value.label;
      controlOptionDto.value = this.optionForm.value.value;
      controlOptionDto.ngxFormlyFormId = this.data.id;
      controlOptionDto.valueConfPageId = this.data.pageId;

      this.statusColorService.createControlOption(controlOptionDto, this.dbName as string).subscribe({
        next: (controlOptionDto: any) => {
          console.log(controlOptionDto);
        },
        // error
      })

    }
  }

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  pickColor(color:any,level:any){
    let statusColorDto = new StatusColorDto;
    statusColorDto.color = color;
    statusColorDto.statusLevel = level;
    statusColorDto.valueConfAttrId = this.data.id;
    statusColorDto.valueConfPageId = this.data.idPage;

    this.statusColorService.createStatusColor(statusColorDto, this.dbName as string).subscribe({      
      next:(data:any) => {
      },
     //error
    });
  }

  close(){
    this.router.navigate([{outlets: {levelpopup:null}}]);
  }

}
